import * as React from 'react'
import cn from 'classnames'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { A, P } from '../../styles/2024/TextStyles'

export const MenuBar = ({ className = '' }) => {
  const history = useHistory()
  const { pathname } = useLocation()

  const navigate = (url) => {
    history.push(url)
  }

  const isActive = (url) => {
    return pathname === url
  }

  const menuItemClass = (url) =>
    cn('inline text-beige-yellow cursor-pointer hover:text-comfort-green', {
      'text-comfort-green border-b border-dotted border-comfort-green !font-["reckless_light"] !mb-[3px]':
        isActive(url),
    })

  return (
    <div className={cn('relative flex mb-0 z-50 w-full', className)}>
      <ul className='flex w-full gap-16 items-center justify-center'>
        <li onClick={() => navigate('/2024/work')} className='w-[80px] text-center'>
          <P className={menuItemClass('/2024/work')}>Work</P>
        </li>
        <li onClick={() => navigate('/2024/grads')} className='w-[80px] text-center'>
          <P className={menuItemClass('/2024/grads')}>Graduates</P>
        </li>
        <li onClick={() => navigate('/2024/events')} className='w-[80px] text-center'>
          <P className={menuItemClass('/2024/events')}>Events</P>
        </li>
        <li onClick={() => navigate('/2024/about')} className='w-[80px] text-center'>
          <P className={menuItemClass('/2024/about')}>About</P>
        </li>
        <li onClick={() => navigate('/2024/letters')} className='w-[80px] text-center'>
          <P className={menuItemClass('/2024/letters')}>Letterbox</P>
        </li>
      </ul>

        <Link to='/2024/search' className='flex flex-row gap-4  items-center justify-end text-beige-yellow  hover:text-comfort-green '>
          <P className='m-0'>Search</P>

          <img src='/static/2024/svg/search.svg' alt='Search' className='w-[26px] h-[26px] inline' />
        </Link>

    </div>
  )
}
